import Scriba from 'react-scriba';

export class DataSignatureElectronique {

    static _chargementSignatureDocumentReservation(idReservation, idOperation, rowGUID) {
        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation,
            "rowGUID": rowGUID
        };

        var url = "api/SignatureElectronique/GetSignatureDocumentReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementEDOCGenOTP(idReservation, idOperation, rowGUID, tel1, email, idContact) {
        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation,
            "rowGUID": rowGUID,
            "tel": tel1,
            "email": email,
            "idContact": idContact
        };

        var url = "api/SignatureElectronique/SW_EDOCGenOTP";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }  

}
